import { render, staticRenderFns } from "./BingIcon.vue?vue&type=template&id=37f362ff&functional=true&"
import script from "./BingIcon.vue?vue&type=script&lang=js&"
export * from "./BingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports